<template>
  <AppDialog>
    <v-card class="pt-2">
      <CloseBtn size="small" class="close" @click="$emit('update:modelValue', false)" />
      <v-card-title>{{ $tt(`eligible_countries_title_${country}`) }}</v-card-title>
      <v-card-text>
        <ul>
          <li v-for="nationality in nationalities">
            {{ tCountry(nationality) }}
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </AppDialog>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import getEligibleNationalities from '~/helpers/eligibility';

const country = inject(countryKeyInjectionKey)!;
const { tCountry } = useLocalization();
const nationalities = await getEligibleNationalities(country);
</script>

<style scoped>
.close {
  position: absolute;
  top: 0;
  right: 0;
}
</style>